export const convertToCamelCase = o => {
  var newO, origKey, newKey, value
  if (o instanceof Array) {
    return o.map(function (value) {
      if (typeof value === 'object') {
        value = convertToCamelCase(value)
      }
      return value
    })
  } else {
    newO = {}
    for (origKey in o) {
      if (o.hasOwnProperty(origKey)) {
        newKey = (origKey.charAt(0).toLowerCase() + origKey.slice(1) || origKey).toString()
        value = o[origKey]
        if (value instanceof Array || (value !== null && value.constructor === Object)) {
          value = convertToCamelCase(value)
        }
        newO[newKey] = value
      }
    }
  }
  return newO
}

export const stringSortAscComparator = (key) =>{
  return (a, b) =>{
    let x = a[key].toLowerCase();
    let y = b[key].toLowerCase();
    if (x < y) {return -1;}
    if (x > y) {return 1;}
    return 0;
  }
}

export const areArrayItemsEqual = (arrayOne, arrayTwo) => {
  return (
    arrayOne.length === arrayTwo.length &&
    arrayOne.every((item) => arrayTwo.includes(item))
  );
};
